module.exports.tagsJson = [{
  type: 'tags',
  id: '0aa58771-6e41-4dc8-b3ed-47a5209277b2',
  attributes: {
    value: 'Fashion',
  },
  selected: false,
}, {
  type: 'tags',
  id: '039d2191-4685-42b4-90dc-cfd0c4688a6e',
  attributes: {
    value: 'Beauty',
  },
  selected: false,
}, {
  type: 'tags',
  id: '8c9800d2-6d33-483d-8264-6e01bd00dcea',
  attributes: {
    value: 'Lifestyle',
  },
  selected: false,
}, {
  type: 'tags',
  id: '034495db-3c1d-41c4-87b3-a4139a202929',
  attributes: {
    value: 'Travel',
  },
  selected: false,
}, {
  type: 'tags',
  id: '9b939e20-5c12-4403-9220-b8f728fe79cb',
  attributes: {
    value: 'Mummy',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'f5a1e17b-edd1-444f-8cea-565adc775549',
  attributes: {
    value: 'Food',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'ee1180ff-2613-4b62-ab50-71815c7a945b',
  attributes: {
    value: 'Health and Fitness',
  },
  selected: false,
}, {
  type: 'tags',
  id: '61b665db-15f8-4f3c-a7f1-93b6fd72531b',
  attributes: {
    value: 'Mental health',
  },
  selected: false,
}, {
  type: 'tags',
  id: '74f3428c-54b6-41f1-aca3-691a2496a964',
  attributes: {
    value: 'Business',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'e7eadd17-1b32-4716-a00a-b9d86d964fe8',
  attributes: {
    value: 'Vegan/Vegetarian',
  },
  selected: false,
}, {
  type: 'tags',
  id: '11b99c3d-629e-40c8-9db5-b81b6856c9a6',
  attributes: {
    value: 'Pets',
  },
  selected: false,
}];



/** WEBPACK FOOTER **
 ** ./src/themes/theme/tags/gifta/tags.js
 **/